import { SVGProps } from 'react';

const SvgDoneSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M8 1.5a6.167 6.167 0 1 0 0 12.333A6.167 6.167 0 0 0 8 1.5ZM.833 7.667a7.167 7.167 0 1 1 14.334 0 7.167 7.167 0 0 1-14.334 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M11.687 5.646a.5.5 0 0 1 0 .708L7.02 11.02a.5.5 0 0 1-.707 0l-2-2a.5.5 0 0 1 .707-.707L6.667 9.96l4.313-4.314a.5.5 0 0 1 .707 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgDoneSmall;
